import { OcsConsoleData } from '@/api/apis/resources';
import { organSuffixes } from '@/constants/case/case.constants';

export const getConsoleSerialNumber = (resourceData?: OcsConsoleData) => {
  if (!resourceData) return '';
  const organSuffix = resourceData.trialProgram ? '' : `${organSuffixes[resourceData.organType]}-`;
  return `${organSuffix}${resourceData.fullSerialNumber}`;
};
